<template>
    <v-menu v-model="menuOpen" offset-y max-height="400" :close-on-content-click="false">
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                small
                outlined
                color="primary"
                v-bind="attrs"
                v-on="on"
                class="mr-2"
            >
                <v-icon small left>mdi-code-brackets</v-icon>
                Inserir Variável
            </v-btn>
        </template>
        <v-list dense>
            <v-list-group
                v-for="(category, index) in variableCategories"
                :key="index"
                :prepend-icon="category.icon"
                no-action
            >
                <template v-slot:activator>
                    <v-list-item-title>{{ category.name }}</v-list-item-title>
                </template>

                <v-list-item
                    v-for="variable in category.variables"
                    :key="variable.code"
                    @click="insertVariable(variable.code)"
                    class="pl-8"
                >
                    <v-list-item-content>
                        <v-list-item-title>{{ variable.label }}</v-list-item-title>
                        <v-list-item-subtitle class="text-caption">
                            <code class="text-xs">[{{ variable.code }}]</code>
                        </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                        <v-tooltip left>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon small v-bind="attrs" v-on="on">mdi-information</v-icon>
                            </template>
                            <span>{{ variable.description }}</span>
                        </v-tooltip>
                    </v-list-item-action>
                </v-list-item>
            </v-list-group>
        </v-list>
    </v-menu>
</template>

<script>
export default {
    name: 'VariableInserter',
    data() {
        return {
            menuOpen: false,
            variableCategories: [
                {
                    name: 'Dados do Cliente',
                    icon: 'mdi-account',
                    variables: [
                        { code: 'CONTRACTOR', label: 'Nome do Contratante', description: 'Nome completo do cliente' },
                        { code: 'CPF', label: 'CPF', description: 'CPF do cliente (formatado)' },
                        { code: 'RG', label: 'RG', description: 'RG do cliente' },
                        { code: 'PAYER_NAME', label: 'Nome do Pagador', description: 'Nome do responsável pelo pagamento' },
                        { code: 'PAYER_CPF', label: 'CPF do Pagador', description: 'CPF do responsável pelo pagamento' }
                    ]
                },
                {
                    name: 'Dados do Serviço',
                    icon: 'mdi-briefcase',
                    variables: [
                        { code: 'SERVICE_NAME', label: 'Nome do Serviço', description: 'Nome do serviço contratado' },
                        { code: 'MINUTES', label: 'Duração (minutos)', description: 'Duração da sessão em minutos' },
                        { code: 'WEEKDAY', label: 'Dia da Semana', description: 'Dia da semana do atendimento' },
                        { code: 'HOUR', label: 'Horário', description: 'Horário do atendimento' },
                        { code: 'FREQUENCY', label: 'Frequência', description: 'Frequência dos atendimentos' }
                    ]
                },
                {
                    name: 'Dados de Pagamento',
                    icon: 'mdi-currency-usd',
                    variables: [
                        { code: 'VALUE', label: 'Valor (R$)', description: 'Valor da sessão em reais' },
                        { code: 'FULL_VALUE', label: 'Valor por Extenso', description: 'Valor escrito por extenso' },
                        { code: 'PAYMENT_TYPE', label: 'Tipo de Pagamento', description: 'Mensal ou por atendimento' },
                        { code: 'CANCEL_VALUE', label: 'Taxa de Cancelamento', description: 'Valor da taxa de cancelamento' }
                    ]
                },
                {
                    name: 'Dados do Contrato',
                    icon: 'mdi-file-document',
                    variables: [
                        { code: 'DATE', label: 'Data do Contrato', description: 'Data de assinatura do contrato' }
                    ]
                },
                {
                    name: 'Dados do Profissional',
                    icon: 'mdi-doctor',
                    variables: [
                        { code: 'DOCTOR_NAME', label: 'Nome do Profissional', description: 'Nome completo do profissional' },
                        { code: 'DOCTOR_EMAIL', label: 'Email do Profissional', description: 'Email de contato do profissional' }
                    ]
                }
            ]
        };
    },
    methods: {
        insertVariable(variableCode) {
            this.$emit('insert', `[${variableCode}]`);
            this.menuOpen = false; // Close menu after inserting variable
        }
    }
};
</script>

<style scoped>
code {
    background-color: #f5f5f5;
    padding: 2px 4px;
    border-radius: 3px;
    font-family: monospace;
}
</style>
